<template>
  <div class="animated fadeIn">
    <b-row v-if="inSetup">
      <b-col>
        <h1>Legacy HIPAAMATE</h1>
        <p>
          The legacy product cannot be renewed. Please begin using the new
          version.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { authService } from "@/services";
import Enumerable from "linq/linq.js";

export default {
  name: "Location",
  data() {
    return {
      coupon: "",
      packages: [],
      ready: true,
      busy: false,
      submitted: false
    };
  },
  computed: {
    ...mapState(["config"]),
    ...mapState("user", {
      maxWorkforce(state) {
        return state.license && state.license.maxWorkforce
          ? state.license.maxWorkforce
          : 0;
      }
    }),
    inSetup() {
      return this.$parent.inSetup;
    }
  },
  methods: {
    ...mapActions({
      alertClear: "alert/clear",
      alertError: "alert/error",
      alertException: "alert/exception",
      fetchProgress: "progress/fetch",
      updateToken: "user/update"
    }),
    loadPackages(coupon) {
      this.busy = true;
      this.alertClear();

      Promise.all([
        this.$store.dispatch("user/fetchLicense"),
        authService.checkCoupon(coupon)
      ])
        .then(values => {
          let couponResponse = values[1];
          if (!couponResponse || !couponResponse.isValid) {
            this.alertError(
              couponResponse && couponResponse.message
                ? couponResponse.message
                : "Invalid coupon code: " + coupon
            );
            coupon = "";
          }
          return coupon;
        })
        .then(coupon => {
          return authService.getPackages(coupon, this.maxWorkforce);
        })
        .then(data => {
          this.packages = data;
          return data;
        })
        .catch(err => {
          this.alertException({
            err,
            message: "Error loading package information."
          });
        })
        .finally(() => {
          this.ready = true;
          this.busy = false;
        });
    },
    getPackageName(workforce) {
      let pkg = Enumerable.from(this.packages)
        .where(function(x) {
          return x.minWorkforce <= workforce && x.maxWorkforce >= workforce;
        })
        .firstOrDefault();

      return pkg ? pkg.title : "";
    },
    onSubmit() {
      this.busy = true;
      this.submitted = true;
      this.alertClear();

      this.$validator
        .validate()
        .then(valid => {
          if (valid) {
            return this.loadPackages(this.coupon);
          }
        })
        .finally(() => {
          this.busy = false;
        });
    },
    done({ id, pkg, token, args }) {
      this.busy = true;
      console.log(
        "Payment[done]: id[%s] pkg[%s] token[%s] args[%s]",
        id,
        JSON.stringify(pkg),
        JSON.stringify(token),
        JSON.stringify(args)
      );

      authService
        .payment(token, id, args)
        .then(response => {
          if (response && response.status === 200) {
            this.$gtag.event("purchase", {
              transaction_id: token.id,
              affiliation: "Stripe",
              value: pkg.price,
              currency: pkg.currency,
              tax: 0,
              shipping: 0,
              items: [
                {
                  id: pkg.id,
                  name: pkg.title,
                  quantity: 1,
                  price: pkg.price
                }
              ]
            });

            return this.$store.dispatch("user/refresh").then(() => {
              // update progress and send to dashboard
              return this.fetchProgress().then(() => {
                this.$router.push("/");
              });
            });
          } else {
            this.alertError(
              response && response.message
                ? response.message
                : "Error processing payment."
            );
          }
        })
        .catch(err => {
          this.alertException({ err, message: "Error processing payment." });
        })
        .finally(() => {
          this.busy = false;
        });
    },
    canceled() {
      this.alertError("Checkout cancelled, please select plan to proceed.");
    }
  },
  created() {
    this.ready = false;

    // check to see if there is a valid coupon/affiliate cache
    let now = new Date();
    let expiration = new Date(localStorage.hmTimestamp);
    expiration.setDate(expiration.getDate() + 90); // expire in 90 days

    // ditch the coupon/affiliate cache content if too old
    if (now.getTime() > expiration.getTime()) {
      delete localStorage.hmTimestamp;
      delete localStorage.hmCoupon;
      delete localStorage.hmAffiliate;
    } else {
      // set coupon based on cached content
      this.coupon = localStorage.hmCoupon;
    }

    this.loadPackages(this.coupon);
  }
};
</script>

<style scoped>
.coupon-container {
  display: grid;
  align-content: center;
  background-color: #ffe0e0;
  border: 1px solid #ffcece;
  border-radius: 5px;
  padding: 15px;
  font-size: 1.2rem;
  color: #000;
  text-align: center;
  margin-bottom: 20px;
}
.coupon-container p {
  margin: 0;
}
.coupon-code {
  background-color: #ffcdcd;
  border: 2px solid #fe6c6c;
  border-radius: 4px;
  font-weight: bold;
  padding: 5px 10px;
}
.pricing {
  background-color: #f4f6f7;
}
.pricing-container {
  margin: 0px 0px;
  padding: 0px;
}
.pricing-row:nth-child(even) {
  margin: 0px 0px;
  padding: 15px;
  font-size: 12px;
  background-color: #e0e0e0;
}
.pricing-row:nth-child(odd) {
  margin: 0px 0px;
  padding: 15px;
  font-size: 12px;
  background-color: #f4f6f7;
}
.plan-title {
  font-size: 24px;
  font-weight: bold;
}
</style>
